// Capture user's page lang to hidden field

import GravityForms from './component.js'

class reffererPage extends GravityForms {
  constructor() {
    super()
    let form = this.form
    if (form) {
      let field = form.querySelector('[id="referrerPage"]')
      let referrerPage = document.referrer
      if (field && (referrerPage !== '')) {
        field.value = referrerPage
      }
    }
  }
}

new reffererPage()


// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/reffererPage.js